import React from "react";
import dayjs from "dayjs";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading
} from "@/common/styles";
import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import CommonDatePicker from "@/common/elements/DatePicker";
import TimePicker from "@/common/elements/TimePicker";
import TextField from "@/common/elements/InputElements/TextField";
import { getRefListNameByID } from "@/util/common_function";
import JailIncidentInvolvedInmateInformation from "./JailIncidentInvolvedInmateInformation";
import JailIncidentInvolvedReportInformation from "./JailIncidentInvolvedReportInformation";
import JailIncidentClassViolationDetail from "./JailIncidentClassViolationDetail";
import JailIncidenSanctionInformation from "./JailIncidenSanctionInformation";
import JailIncidentInmateAdmitsGuilt from "./JailIncidentInmateAdmitsGuilt";
import JailIncidenHearingInformation from "./JailIncidenHearingInformation";
import JailIncidentIReviewHearings from "./JailIncidentIReviewHearings";

const JailIncidentsInvolvedDetail = ({ data, bookings }) => {
  if (!data) return null; // Ensure data exists

  const {
    approved,
    administratorStatus,
    supervisorStatus,
    administratorDate,
    administratorTime,
    administratorRejectReason,
    supervisorDate,
    supervisorTime,
    supervisorRejectReason,
    supervisorStaffID,
    administratorStaffID,
    jailIncidentsInvolvementType,
  } = data;


  const getStaffName = (staffID) => {
    return getRefListNameByID("Staff", staffID, true) || "N/A";
  };

  const initialValues = {
    approved: approved,
    supervisorName: getStaffName(supervisorStaffID),
    supervisorStatus: (supervisorStatus || "").trim() || "-",
    supervisorDate: supervisorDate ? dayjs(supervisorDate, "MM/DD/YYYY") : null,
    supervisorTime: supervisorTime ? dayjs(supervisorTime, "HH:mm") : null,
    supervisorRejectReason: supervisorRejectReason || "",
    administratorName: getStaffName(administratorStaffID),
    administratorStatus: (administratorStatus || "").trim() || "-",
    administratorDate: administratorDate ? dayjs(administratorDate, "MM/DD/YYYY") : null,
    administratorTime: administratorTime ? dayjs(administratorTime, "HH:mm") : null,
    administratorRejectReason: administratorRejectReason || "",
  };

  return (
    <>
      {/* Inmate Information and Report Information are always shown */}
      <JailIncidentInvolvedInmateInformation
        bookings={bookings}
        disabled={true}
      />
      <JailIncidentInvolvedReportInformation
        data={data}
        disabled={true}
      />

      {jailIncidentsInvolvementType === "Violator" ? (
        <>
          <JailIncidentClassViolationDetail
            data={data}
            disabled={true}
          />
          <JailIncidenSanctionInformation
            data={data}
            disabled={true}
          />
          <JailIncidentInmateAdmitsGuilt
            data={data}
            disabled={true}
          />
          <JailIncidenHearingInformation
            data={data}
            disabled={true}
          />
        </>
      ) : null}

      {/* Review Hearings Section is always shown */}
      <JailIncidentIReviewHearings
        data={data}
        disabled={true}
      />

      {jailIncidentsInvolvementType === "Violator" ? (<Form
        name="jailIncidentDetailForm"
        initialValues={initialValues}
        disabled
      >
        {/* Approval Section */}
        <StyledSectionHeading marginTop="20px">
          <span>Approval Information</span>
        </StyledSectionHeading>
        <StyledGridRow>
          <StyledGridCol marginBottom="15px">
            <FormItem
              label="Approved?"
              layout="horizontal"
              labelPostion="label-right"
              name="approved"
              valuePropName="checked"
            >
              <Checkbox disabled />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        {/* Supervisor Section */}
        <StyledSectionHeading marginBottom="15px">
          <span>Supervisor</span>
        </StyledSectionHeading>
        <StyledGridRow>
          <StyledGridCol lg={12}>
            <FormItem label="Supervisor Name" name="supervisorName">
              <div>{getStaffName(supervisorStaffID)}</div>
            </FormItem>
          </StyledGridCol>
          <StyledGridCol>
            <StyledGridRow gutter={16}>
              <StyledGridCol>
                <FormItem label="Status" name="supervisorStatus">
                  <div>{(supervisorStatus || "").trim() || "-"}</div>
                </FormItem>
              </StyledGridCol>
              <StyledGridCol>
                <FormItem label="Date" name="supervisorDate">
                  <CommonDatePicker
                    showTime={false}
                    format="MM/DD/YYYY"
                    disabled
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol>
                <FormItem label="Time" name="supervisorTime">
                  <TimePicker disabled />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </StyledGridCol>
          <StyledGridCol xs={24} lg={24}>
            <FormItem label="Reject Reason" name="supervisorRejectReason">
              <TextField
                inputType="textarea"
                rows="2"
                disabled
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        {/* Administrator Section */}
        <StyledSectionHeading marginBottom="15px">
          <span>Administrator</span>
        </StyledSectionHeading>
        <StyledGridRow>
          <StyledGridCol lg={12}>
            <FormItem label="Administrator Name" name="administratorName">
              <div>{getStaffName(administratorStaffID)}</div>
            </FormItem>
          </StyledGridCol>
          <StyledGridCol>
            <StyledGridRow gutter={16}>
              <StyledGridCol>
                <FormItem label="Status" name="administratorStatus">
                  <div>{(administratorStatus || "").trim() || "-"}</div>
                </FormItem>
              </StyledGridCol>
              <StyledGridCol>
                <FormItem label="Date" name="administratorDate">
                  <CommonDatePicker
                    showTime={false}
                    format="MM/DD/YYYY"
                    disabled
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol>
                <FormItem label="Time" name="administratorTime">
                  <TimePicker disabled />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </StyledGridCol>
          <StyledGridCol xs={24} lg={24}>
            <FormItem label="Reject Reason" name="administratorRejectReason">
              <TextField
                inputType="textarea"
                rows="2"
                disabled
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
      ) : null}
    </>
  );
};

export default JailIncidentsInvolvedDetail;
